import { useCallback } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { DEFAULT_CITY, ROUTES } from '../routes';

export const useSearchNavigate = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { city } = useParams();
  const cityParam = city || DEFAULT_CITY;

  const navigateWithSearchParams = useCallback(
    (route: typeof ROUTES[keyof typeof ROUTES]) =>
      navigate({ pathname: route({ city: cityParam }), search }),
    [navigate, search, cityParam],
  );

  return navigateWithSearchParams;
};
